<template>
  <div class="newsCenter">
    <el-col :span="14" style="width:100%">
            <div class="grid-content bg-purple newsNav">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="最新" name="first">
                  <div class="news" v-for="(item,index) in $store.state.newsList" :key="index">
                    <div class="left">
                      <div class="newsType">{{item.newsType}}</div>
                    <div class="newsTittle">{{item.newsTittle}}</div>
                    </div>
                    <div class="newsDate">{{item.newsDate}}</div>
                  </div>
                </el-tab-pane>
                
                <el-tab-pane label="新闻" name="second">
                  <div class="news" v-for="(item,index) in $store.state.newsList" :key="index">
                    <div class="left">
                      <div class="newsType">{{item.newsType}}</div>
                    <div class="newsTittle">{{item.newsTittle}}</div>
                    </div>
                    <div class="newsDate">{{item.newsDate}}</div>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="公告" name="third">
                  <div class="news" v-for="(item,index) in $store.state.newsList" :key="index">
                    <div class="left">
                      <div class="newsType">{{item.newsType}}</div>
                    <div class="newsTittle">{{item.newsTittle}}</div>
                    </div>
                    <div class="newsDate">{{item.newsDate}}</div>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="攻略" name="fourth">
                  <div class="news" v-for="(item,index) in $store.state.newsList" :key="index">
                    <div class="left">
                      <div class="newsType">{{item.newsType}}</div>
                    <div class="newsTittle">{{item.newsTittle}}</div>
                    </div>
                    <div class="newsDate">{{item.newsDate}}</div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>

          <div class="block">
  <el-pagination
    layout="prev, pager, next"
    :total="50">
  </el-pagination>
</div>

    <router-view />

  </div>
</template>

<script>
export default {
  data(){
    return{
      activeName: "first",
    }
  },

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
}
</script>

<style scoped>
.newsCenter {
  background: #FFFFE6;
  border: 2px solid #89c33f ;
  margin: 5% 0;
  padding: 5%;
  color: #603813;
  font-size: 16px;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* font-weight: bold; */
}
.newsNav {
  width: 100%;
}
.news {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  font-size: 14px;
}

.el-tabs__active-bar {
  display: none
}
.el-tabs__nav-wrap::after {
  display: none
}
.el-col-14 .el-col{
    width: 100%;
}
.left {
  display: flex;
  margin:0  ;
}
.el-pagination button:disabled {
  background-color: #FFFFE6;
}
.el-pager li {
    background-color: #FFFFE6;
}
.el-pagination .btn-next {
    background-color: #FFFFE6;

}
@media screen and (max-width: 700px) {
.el-col-14 .el-col{
    width: 100%;
}
}
</style>


// WEBPACK FOOTER //
// src/components/newsCenter.vue